/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
import { Command, PopularityData } from '../interfaces';

export enum POPULARITY_SORT {
    POPULAR = 'POPULAR',
}

/**
 * Sort based on the product popularity.
 * The popularity sort will take into account 3 different factors:
 * - Custom popularity override value
 * - Popularity value
 * - If the product is out of stock or not
 *
 * The products will be ordered by:
 * - Highest custom popularity value, then popularity value.
 * - Any out of stock products should always be sorted to the end of the listing.
 *
 * Example:
 * You have 5 products.
 * Product A with a custom popularity override value of 10.
 * Product B with a custom popularity override value of 25.
 * Product C with a popularity value of 1200.
 * Product D with a popularity value of 2900 which is out of stock.
 * Product E with a popularity value of 2000.
 * This would sort as:  B, A, E, C, D.
 * @param data a treatment
 * @returns PopularityData[]
 */

const sortByPopularityOverride = (a: PopularityData, b: PopularityData) => b.popularityOverride - a.popularityOverride;
const sortByPopularity = (a: PopularityData, b: PopularityData) => b.popularity - a.popularity;

export const popularitySort = <T extends PopularityData>(data: T[], keys: keyof typeof POPULARITY_SORT) => {
    if (data === null) {
        data = [];
    }

    if (data.length === 0) {
        return data;
    }

    if (keys === POPULARITY_SORT.POPULAR) {
        // Get items with a popularity override and stock.
        const popularityOverride = data.filter((item: PopularityData) => (
            item.popularityOverride && item.anyVariantInStock
        )).sort(sortByPopularityOverride);

        // Get items with no popularity override and stock.
        const popularity = data.filter((item: PopularityData) => (
            !item.popularityOverride && item.anyVariantInStock
        )).sort(sortByPopularity);

        // Get items with a popularity override and no stock.
        const outOfStockPopularityOverride = data.filter((item: PopularityData) => (
            item.popularityOverride && !item.anyVariantInStock
        )).sort(sortByPopularityOverride);

        // Get items with no popularity override and no stock.
        const outOfStockPopularity = data.filter((item: PopularityData) => (
            !item.popularityOverride && !item.anyVariantInStock
        )).sort(sortByPopularity);

        // Combines the items in the correct order, so they are sorted by items with stock and items without,
        // and then both in and out of stock are sorted by popularity override as priority, then popularity
        // if there is no popularity override.
        return [
            ...popularityOverride,
            ...popularity,
            ...outOfStockPopularityOverride,
            ...outOfStockPopularity
        ];
    }

    return data;
};

export class PopularitySortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: PopularityData[], keys: keyof typeof POPULARITY_SORT) {
        return popularitySort(data, POPULARITY_SORT[keys]);
    }
}
